<template>
  <div class='card'>
    <navigator class='header' :title="title"></navigator>

    <mt-field label="姓名" placeholder="请输入姓名" v-model="userCard.name" :state='errStateList.name'></mt-field>
    <van-field class="magh"
        readonly
        clickable
        name="picker"
        :value="value"
        label="所属园区"
        label-width="100px"
        placeholder="点击选择所属园区"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>

    <mt-field label="手机" placeholder="请输入手机" v-model="userCard.phone" :state='errStateList.phone'></mt-field>

     <mt-field label="职位" v-model="userCard.position"></mt-field>

    <mt-field label="企业名称" v-model="userCard.corpName" :state='errStateList.corpName'></mt-field>

    <mt-field label="地址"  v-model="userCard.address" :state='errStateList.address'></mt-field>

    <mt-field label="座机" v-model="userCard.tel"></mt-field>

    <mt-field label="邮箱" v-model="userCard.email"></mt-field>

    <!-- 错误提示 -->
    <mt-popup v-model="errorFlag" position="top" :modal='false' popup-transition="popup-fade"> {{errMsg}} </mt-popup>

    <div class='footer'>
      <mt-button @click.native='edit'>保存</mt-button>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { Toast } from 'vant';

export default {
  data() {
    return {
      title: '编辑名片',
      userCard: {
        name: '',
        phone: '',
        position: '',
        corpName: '',
        address: '',
        tel: '',
        email: '',
      },
      parkId:'',
      value: '',
      columns: [
        { text: '福田天安', value: 1000 },
        { text: '重庆天安', value: 1001 },
        { text: '佛山天安', value: 1002 },
        { text: '龙岗天安', value: 1003 },
        { text: '东莞天安', value: 1004 },
        { text: '广州番禺天安', value: 1005 },
        { text: '深业U中心', value: 1006 },
        { text: '俊安苑', value: 1007 },
        { text: '常州天安', value: 1008 },
        { text: '天津天安', value: 1010 },
        { text: '江阴天安', value: 1011 },
        { text: '青岛天安', value: 1012 },
        { text: '高尔夫花园', value: 1015 },
        { text: '武汉天安', value: 1016 },
        { text: '中山天安', value: 1017 },
        { text: '西安天安', value: 1018 },
        { text: '上海天安', value: 1019 },
        { text: '广东南海', value: 1020 },
      ],
      showPicker: false,
      errorFlag: false,
      errMsg: '',
      duration: 2000,
      errStateList: {
        name: '',
        phone: '',
        corpName: '',
        address: '',
      },
    };
  },
  methods: {
    getUserCard() {
      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/detail`, {}, {
        headers: {
          token: this.token,
        },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.value = this.getText(res.resData.parkId);
          this.userCard = res.resData.userCardInfo;
          if (!this.userCard.phone) {
            this.userCard.phone = res.resData.userMobile;
          }
        }
      });
    },
    getText(value){
        for(var s = 0;s<this.columns.length;s++){
          if(value == this.columns[s].value){
              return this.columns[s].text
          }
        }
    },
    edit() {
      if (!this.userCard.name) {
        this.errorFlag = true;
        this.errMsg = '姓名不能为空';
        this.errStateList.name = 'error';
        setTimeout(() => {
          this.errorFlag = false;
        }, this.duration);
        return;
      }
      if (!this.userCard.phone) {
        this.errorFlag = true;
        this.errMsg = '手机号不能为空';
        this.errStateList.phone = 'error';
        setTimeout(() => {
          this.errorFlag = false;
        }, this.duration);
        return;
      }
      if (!this.userCard.corpName) {
        this.errorFlag = true;
        this.errMsg = '企业名称不能为空';
        this.errStateList.corpName = 'error';
        setTimeout(() => {
          this.errorFlag = false;
        }, this.duration);
        return;
      }
      if (!this.userCard.address) {
        this.errorFlag = true;
        this.errMsg = '企业地址不能为空';
        this.errStateList.address = 'error';
        setTimeout(() => {
          this.errorFlag = false;
        }, this.duration);
        return;
      }

      this.modifyHttp();
    },
    onConfirm(value) {
      this.value = value.text;
      this.showPicker = false;
      this.parkId = value.value;
      console.log(value)
    },
    chereParkId() {  // 修改用户所属园区
      this.$http.post(`${this.URL_PREFIX}/app/modify/user/info`, {
        parkId:this.parkId,
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          console.log(res);
        }
      });
    },
    modifyHttp() {
      this.$http.post(`${this.URL_PREFIX}/app/modify/user/card/info`, {
        ...this.userCard,
      }, {
        headers: { token: this.token }
      }).then((response) => {
        const res = response.data;
        const errorMsg = res.resDesc;
        if (res.resCode === '10000') {
          this.chereParkId();
          Toast.success({ duration: this.duration, message:  '名片修改成功'});
        } else {
          Toast.fail({ duration: this.duration, message:  errorMsg});
        }
      });
    },
  },
  watch: {
    userCard: {
      deep: true,
      handler() {
        if (this.userCard.name) {
          this.errStateList.name = '';
        }
        if (this.userCard.phone) {
          this.errStateList.phone = '';
        }
        if (this.userCard.corpName) {
          this.errStateList.corpName = '';
        }
        if (this.userCard.address) {
          this.errStateList.address = '';
        }
      },
    },
  },
  computed: {
    ...mapGetters(['token']),
  },
  created() {
    if (!this.token) {
      this.$root.eventHub.$emit('login', this.$route.fullPath);
    } else {
      this.getUserCard();
    }
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';
.card{
  position: relative;
  height: 100%;
  .header{
    margin-bottom: .133333rem;
  }
  .mint-field{
    margin-bottom: .026667rem;
    height: 1.173333rem;
    line-height: 88px;
    font-size: .4rem;
    color: rgb(67, 67, 67);
  }
  .footer{
    padding: px2rem(16) px2rem(24);
    background-color: #f5f5f5;
    margin-top: .4rem;
    box-sizing: border-box;
    width: 100%;
    .mint-button{
      width: 100%;
      height: 1.04rem;
      background: $color-main;
      color: #fff;
      font-size: .48rem;
    }
  }
}
.magh{
  padding: 10px!important;
}
.mint-popup{
  padding: .266667rem;
  box-sizing: border-box;
  width: 100%;
  text-align: center;
  font-size: .4rem;
  color: #fff;
  background: rgba(0, 0, 0, 0.6);
}
</style>


// WEBPACK FOOTER //
// src/pages/personal/EditCard.vue